import ListenNative from "@/jsbridge/service/listenNative";
import { store } from "@/main";
import SwitchBackgroundPosition, {
  SwitchPositionTypes
} from "@/utils/switch_background/switch_background_position";
import { UPDATE_GX_SETTING_DATA } from "@/store/constants/setting_types";
import * as types from "@/store/constants/cg_user_types";
import * as cgConst from "@/api/cg/base/cg_const";
import {
  GETTER_ONE_INS_LOGIN_USER_ID,
  REFRESH_CURRENT_INS_UNSR_INFO
} from "@/store/constants/ins_user_info_types";
import { RERESH_CURRENT_USER_INS_MEDIA } from "@/store/constants/ins_media_types";
import AppLifeCycle from "@/utils/app_lifecycle/app_lifecycle";
class SwitchBackground {
  // 切换至后台
  public enterBackGround() {
    AppLifeCycle.addBackListener(() => {
      const position = SwitchBackgroundPosition.get();
      console.log("=== did_enter_background ===");
      // 没有position代表用户手动切换前后台，需要刷新ins信息
      if (!position) {
        this.updateCurrentInsUser();
      }
      // 刷新客户端参数settings: // catch需要捕获不处理
      store.dispatch(UPDATE_GX_SETTING_DATA, cgConst.COMMON_KEYS).catch(e => {
        void 0;
      });
    });
  }

  // 切换至前台
  public enterForeGround() {
    AppLifeCycle.addFrontListener(() => {
      console.log("=== foreground ===");
      const position = SwitchBackgroundPosition.get();

      // 如果当前的position是不需要刷新用户信息，
      if (position !== SwitchPositionTypes.NOT_REQUIRE_REFRESH) {
        // catch需要捕获不处理
        store.dispatch(types.UPDATE_GX_USER_INFO, ["coins"]).catch(e => {
          void 0;
        });
      }
      SwitchBackgroundPosition.clearPosition();
    });
  }

  public updateCurrentInsUser() {
    const loginUserId = store.getters[GETTER_ONE_INS_LOGIN_USER_ID];
    if (!loginUserId) {
      return;
    }
    // 更新当前的user info
    store.dispatch(REFRESH_CURRENT_INS_UNSR_INFO).catch((error: any) => {
      //
    });
    // // 更新当前的user media
    store.dispatch(RERESH_CURRENT_USER_INS_MEDIA).catch((error: any) => {
      //
    });
  }

  public init() {
    this.enterForeGround();
    this.enterBackGround();
  }
}

export default new SwitchBackground();
